/**
 * Shared display helpers for orders: split payment sections + disclaimers.
 * Kept as pure functions so both Cart, Checkout, PortalOrders, OrderPrint
 * and Admin Orders render consistently.
 */
import React from "react";

export function unitSummary(item) {
  const bits = [];
  if (item?.unit_size) bits.push(`${item.unit_size} per unit`);
  if (item?.case_size) bits.push(`${item.case_size} per case`);
  return bits.join(" · ");
}

export function normalizePM(pm) {
  if (pm === "cash_only") return "cash";
  if (pm === "cash") return "cash";
  return "electronic_or_cheque"; // includes legacy etransfer/cheque + any/undefined
}

/** Payment-method badge used on catalogue + order rows. */
export function PaymentBadge({ method, size = "sm" }) {
  const pm = normalizePM(method);
  const cls = pm === "cash"
    ? "bg-soda text-paper border-soda"
    : "bg-paper text-ink border-ink";
  const label = pm === "cash" ? "Cash only" : "E-Transfer / Cheque";
  return (
    <span
      className={`inline-block border px-2 py-0.5 font-bold uppercase tracking-widest ${cls} ${size === "sm" ? "text-[9px] md:text-[10px]" : "text-[10px] md:text-xs"}`}
    >
      {label}
    </span>
  );
}

/** Small notice explaining tax is added on the final invoice. */
export const TAX_NOTICE_ELEC = "Applicable tax will be added to the E-transfer/Cheque amount on the final invoice.";
export const TAX_NOTICE_CASH = "No tax added to the Cash Total. Cash is due to our driver on delivery.";

/** Standard confirmation-vs-invoice disclaimer. */
export const CONFIRMATION_DISCLAIMER =
  "Your order has been received and confirmed for processing. This is an order confirmation only and is not an invoice or receipt. GTA Wholesale Supply will review the order and issue the final invoice separately. Applicable tax will be added to the E-transfer/Cheque portion on the final invoice.";
